import React, {useEffect, useRef, useState} from "react";
import TablePage from "../tablePage/TablePage";
import {internalApi} from "../../common/axios";
import toast from "react-hot-toast";
import {Input, Space, Button, Table} from "antd";
import {Sorter} from "../../shared/components/Sorter";
import EditableNumber from "../../shared/components/text/EditableNumber";
import GoToUserInfoButton from "../../shared/components/buttons/GoToUserInfoButton";

const filter = ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
    <div style={{padding: 8}}>
        <Input
            type="number"
            placeholder="입력"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{width: 188, marginBottom: 8, display: "block"}}
        />
        <Button type="primary" onClick={() => confirm()} size="small" style={{width: 90, marginRight: 8}}>
            적용
        </Button>
        <Button onClick={() => clearFilters()} size="small" style={{width: 90}}>
            초기화
        </Button>
    </div>
)

const HackLogTab = () => {
    const [rows, setRows] = useState([]);
    const [localData, setLocalData] = useState([]);


    const [diamond, setDiamond] = useState();
    const [energy, setEnergy] = useState();
    const [tempDiamond, setTempDiamond] = useState(diamond);
    const [tempEnergy, setTempEnergy] = useState(energy);
    const [isEditing, setIsEditing] = useState(false);
    const [reload, setReload] = useState(0);

    const refreshRef = useRef(null);

    const handleDelete = (record) => {
        internalApi.delete(`logs/hack/${record.seq}`).then((res) => {
            toast.success(res.data.message);

            if (refreshRef.current) {
                refreshRef.current();
            }
            setReload(prev => prev + 1);
        }).catch((err) => {
            console.error('Error delete failed:', err);
            toast.error('로그 삭제 실패!');
        });
    };

    useEffect(() => {
        toast.loading('데이터를 가져오는 중...');
        internalApi.get(`logs/hack`).then((res) => {
            // localData = res.data.rows;
            // 로컬데이터는 테이블 전체
            const serverData = res.data.rows.map((row, idx) => ({...row, key: idx}));
            setLocalData(serverData);
            setRows(serverData);
            toast.dismiss();
        }).catch((err) => {
            console.error('Error load failed:', err);
            toast.error('핵 로그 읽어 오기 실패!');
            toast.dismiss();
        });
    }, [reload]);

    useEffect(() => {
        internalApi.get(`logs/hack/hackInfo`).then((res) => {
            setDiamond(res.data.hackInfo.DIAMOND);
            setEnergy(res.data.hackInfo.ENERGY);
        }).catch((err) => {
            console.error('Error load failed:', err);
            toast.error('핵 정보 읽어 오기 실패!');
        });
    }, []);
    const columns = [
        {
            title: '유저 PID',
            dataIndex: 'pid',
            search: true,
        },
        {
            title: '닉네임',
            dataIndex: 'nickname',
            search: true,
        },
        {
            title: '보석',
            dataIndex: 'diamond',
        },
        {
            title: '에너지',
            dataIndex: 'energy',
        },
        {
            title: '별',
            dataIndex: 'star',
        },
        {
            title: '가차코인',
            dataIndex: 'gachaCoin'
        },
        {
            title: '유저 정보',
            dataIndex: 'pid',
            render: (pid) => <GoToUserInfoButton pid={pid}/>,
        }
    ];
    const expandColumns = [
        {
            title: '유저 PID',
            dataIndex: 'pid',
            search: true,
        },
        {
            title: '닉네임',
            dataIndex: 'nickname',
            search: true,
        },
        {
            title: '이전 다이아몬드',
            dataIndex: 'prevDiamond',
            filterDropdown: filter,
            onFilter: (value, record) => record.prevDiamond >= value,
        },
        {
            title: '이후 다이아몬드',
            dataIndex: 'afterDiamond',
            filterDropdown: filter,
            onFilter: (value, record) => record.afterDiamond >= value,
        },
        {
            title: '변경 다이아몬드',
            dataIndex: 'modifyDiamond',
            filterDropdown: filter,
            onFilter: (value, record) => record.modifyDiamond >= value,
        },
        {
            title: '이전 에너지',
            dataIndex: 'prevEnergy',
            filterDropdown: filter,
            onFilter: (value, record) => record.prevEnergy >= value,
        },
        {
            title: '이후 에너지',
            dataIndex: 'afterEnergy',
            filterDropdown: filter,
            onFilter: (value, record) => record.afterEnergy >= value,
        },
        {
            title: '변경 에너지',
            dataIndex: 'modifyEnergy',
            filterDropdown: filter,
            onFilter: (value, record) => record.modifyEnergy >= value,
        },
        {
            title: '저장 날짜',
            dataIndex: 'created',
            // render: (created) => dayjs.unix(created).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) => Sorter.DATE(a.created, b.created),
        },
        {
            title: '무죄',
            render: (text, record) => <Button onClick={() => handleDelete(record)}>Delete</Button>,
        }
    ];

    const handleSave = () => {
        setIsEditing(false);

        // 백으로 보내기
        internalApi.post(`logs/hack/modify`, {diamond: Number(diamond), energy: Number(energy)}).then((res) => {
            toast.success(res.data.message);
            if (refreshRef.current) {
                refreshRef.current();
            }
        }).catch((err) => {
            console.error('Error modify failed:', err);
            toast.error('핵 기준 설정 실패!');
        });
    };

    const handleCancel = () => {
        setDiamond(tempDiamond);
        setEnergy(tempEnergy);
        setIsEditing(false);
    };

    const handleEdit = () => {
        setTempDiamond(diamond);
        setTempEnergy(energy);
        setIsEditing(true);
    };

    const expandedRowRender = (record) => (
        <Table columns={expandColumns}
            // [수정] props.originData 대신 scope 내에 있는 localData를 직접 사용하도록 수정했습니다.
               dataSource={localData.filter((el) => el.pid === record.pid)}
               pagination={false}
        />
    );

    const props = {
        columns,
        localData: rows,
        refreshRef,
        expandedRowRender,
        originData: localData,
    }

    return (
        <>
            <p style={{
                margin: '10px 0',
                fontSize: '18px',
                display: 'flex',
                alignItems: 'center',
                height: '32px',  // 고정 높이 추가
                lineHeight: '32px',  // 텍스트와 인풋 높이 맞춤
            }}>
                <strong>다이아몬드 </strong>
                {isEditing ? (
                    <>
                        <EditableNumber value={diamond} onChange={setDiamond}/>
                        <strong style={{marginLeft: '12px'}}>에너지 </strong>
                        <EditableNumber value={energy} onChange={setEnergy}/>
                        <Space size="small" style={{marginLeft: '8px'}}>
                            <Button type="primary" size="small" onClick={handleSave}>
                                적용
                            </Button>
                            <Button size="small" onClick={handleCancel}>
                                취소
                            </Button>
                        </Space>
                    </>
                ) : (
                    <>
                    <span style={{marginLeft: '4px', marginRight: '12px'}}>
                        <em onClick={handleEdit} style={{color: 'red', cursor: 'pointer'}}>
                            {diamond}
                        </em>
                        ↑
                    </span>
                        <strong>에너지 </strong>
                        <span style={{marginLeft: '4px'}}>
                        <em onClick={handleEdit} style={{color: 'red', cursor: 'pointer'}}>
                            {energy}
                        </em>
                        ↑ 저장됩니다.
                    </span>
                    </>
                )}
            </p>
            <TablePage {...props} />
        </>
    );
};

export default HackLogTab;